import { useEffect } from "react";
import Modal from "../../layouts/Modal";
import { ICategorySearchTerm } from "../../models/Category/Category";
import { TextInput } from "../shared/Inputs/TextInput";
import LoadingWheel from "../shared/LoadingWheel";
import { set, useForm } from "react-hook-form";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import useCategorySearchTerms from "../../data/Category/useCategorySearchTerms";

export default function CategorySearchTermModal({
    open,
    setOpen,
    searchTerm
}: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    searchTerm: ICategorySearchTerm | undefined;
}) {
    const { register, setValue, getValues, handleSubmit, watch} = useForm<any>();
    const { update } = useCategorySearchTerms();

    const onSubmit = (data: any) => {
        const updatedSearchTerm: any = {
            categoryId: data.categoryId,
            include: data.include,
            exclude: data.exclude,
        };

        console.log("Submitting search term:", updatedSearchTerm);

        update.mutate(updatedSearchTerm, {
            onSuccess: () => {
                console.log("Search term updated successfully");
                setOpen(false);
            },
            onError: (error) => {
                console.error("Error updating search term:", error);
            }
        });

    }

    useEffect(() => {
        if (!open) return;
        if (!searchTerm) return;

        // Reset form values when modal opens
        setValue("categoryId", searchTerm.categoryId);
        setValue("include", searchTerm.include ?? "");
        setValue("exclude", searchTerm.exclude ?? "");

    }, [searchTerm, open]);

    if (!searchTerm) return (
        <Modal open={open} setOpen={setOpen} width="sm:max-w-2xl">
            <LoadingWheel />  
        </Modal>
    )
  
    return (
        <Modal open={open} setOpen={setOpen} width="sm:max-w-2xl">
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Category Search Term ({searchTerm.categoryName})</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-4 ">
                <input type="hidden" {...register("categoryId")} />
                <TextInput
                    label="Include"
                    register={register}
                    registerName="include"
                    richText={true}
                />
                <TextInput
                    label="Exclude"
                    register={register}
                    registerName="exclude"
                    richText={true}
                />
                <div className="flex items-center justify-between">
                    <ButtonInput
                        isSubmit={false}
                        classes="mt-4 !bg-slate-600 hover:!bg-slate-700"
                        label="Cancel"
                        disabled={false}
                        onClick={() => setOpen(false)}
                    />
                    <ButtonInput
                        isSubmit={true}
                        classes="mt-4"
                        label="Save Category Search Term"
                        disabled={false}
                        onClick={() => {}}
                    />
                </div>
            </form>
        </Modal>
  );
}